import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.couponCategories.title',
    defaultMessage: 'Coupons',
    description: 'title of the coupons page',
  },
  create: {
    button: {
      id: 'pages.couponCategories.create.button',
      defaultMessage: 'New category',
      description: 'title of the create category button',
    },
  },
  createCouponCategoryDrawer: {
    title: {
      id: 'pages.couponCategories.createDrawer.title',
      defaultMessage: 'Create coupon category',
      description: 'title of the coupon category drawer',
    },
  },
  feedback: {
    couponCategoryCreated: {
      id: 'pages.couponCategories.feedback.couponCategoryCreated',
      defaultMessage: 'Coupon category created',
      description: 'notification on successful creation of coupon category',
    },
    couponCategoryNotCreated: {
      id: 'pages.couponCategories.feedback.couponCategoryNotCreated',
      defaultMessage: 'Coupon category could not be created',
      description: 'notification on failed creation of coupon category',
    },
    couponCategoryUpdated: {
      id: 'pages.couponCategories.feedback.couponCategoryUpdated',
      defaultMessage: 'Coupon category updated',
      description: 'notification on successful update of coupon category',
    },
    couponCategoryNotUpdated: {
      id: 'pages.couponCategories.feedback.couponCategoryNotUpdated',
      defaultMessage: 'Coupon category could not be updated',
      description: 'notification on failed update of coupon category',
    },
  },
};

export default defineMessages(translations);
